import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { Form, FormikContextType, FormikProvider } from "formik";

interface Props {
  children: ReactNode;
  formik: FormikContextType<any>;
}

export const FormContainer: FC<Props> = ({ children, formik }) => {
  return (
    <FormikProvider value={formik}>
      <Flex
        as={Form}
        direction="column"
        gap={{ base: 10, md: "3.5rem" }}
        w="full"
      >
        {children}
      </Flex>
    </FormikProvider>
  );
};
